import structuredClone from '@ungap/structured-clone';

import { FlatNode, Tree } from '../pages/mindmap/types';
import { regenerateNode } from './regenerate-node';

/**
 * Converts trees to an array of flat nodes and regenerates each node's
 * id while keeping the hierarchical structure by adjusting the PIDs.
 * @param children The three's themself.
 * @param idMap An object with the node's old id as key and new id as value.
 *              Can be used to set the PID of the 'root' node manually.
 * @returns A FlatNode array with newly generated ids.
 */
export const copyTreeToNodes = (
  children: Tree[] | undefined,
  idMap: Record<string, string>,
  { keepIds = false, ignoreIds = [] }: { keepIds: boolean; ignoreIds?: string[] },
): FlatNode[] => {
  let flatNodes = [];
  // don't modify children from call
  children = structuredClone(children);

  if (children) {
    let child: Tree | undefined;
    while ((child = children.shift())) {
      const shouldIgnoreChild = ignoreIds.includes(child.id);

      if (!shouldIgnoreChild) {
        const childCopy = regenerateNode(child, keepIds, idMap);
        flatNodes.push(childCopy);

        if (child.children) {
          children.push(...child.children);
        }
      }
    }
  }

  return flatNodes;
};
